export default __webpack_public_path__ + "static/media/4.2ef84e53.png";